import TierHelper from '@/utils/lineitem-tier-helper'
import {EventBus} from '@/utils/event-bus'
import UpdateSubUtils from "@/utils/update-sub"

export default {
  computed: {
    cartNote(){
      var hpData = UpdateSubUtils.hpContent()
      if(hpData && UpdateSubUtils.isCheckoutExisting() && UpdateSubUtils.isScheduledChange()) {
        var subData = this.$store.getters.subscriptions.find(sub => sub.id == hpData.subscription_handle)
        if(hpData.subscription.change_option == UpdateSubUtils.END_OF_TERM && subData && (subData.current_term_end || subData.next_billing_at)) {
          return this.t('order_summary.sub_change.eot_note', 
                          {
                            sub_change_date: this.date(subData.current_term_end) || 
                                              this.date(subData.next_billing_at)
                          });
        }
        else if(hpData.subscription.change_option == UpdateSubUtils.SPECIFIC_DATE && hpData.subscription.changes_scheduled_at) {
          if(this.$store.getters.hasTrialPeriod) {
            return this.t('order_summary.sub_change.charges_on_te', {sub_change_date: this.date(UpdateSubUtils.getSubChangeDate())})
          }
          else if(UpdateSubUtils.isImmediateChargePresent(this.$store.getters.order_estimate_holder)){
            return  this.t('order_summary.sub_change.eot_note', {sub_change_date: this.date(UpdateSubUtils.getSubChangeDate())});  
          }
          return  this.t('order_summary.sub_change.no_charges', {sub_change_date: this.date(UpdateSubUtils.getSubChangeDate())});
        }
      }
      if(this.$store.getters.hasTrialPeriod){
        return this.t('cart.note.plan.trial', this.$store.getters.plan_placeholder);
      }
      return this.t('cart.note.plan.no_trial', this.$store.getters.plan_placeholder);
    },
    isSingleItem() {
      return this.$store.getters.order_cart_items.length == 1;
    }
  },
	methods: {
    removeDiscount(couponId) {
      this.$store.dispatch('remove_coupon', {id: couponId}).then((success, error) => {
        if (success) {
          EventBus.$emit('hp_log', {action:'coupon_removed'});
          if(this.$store.getters.is_checkout_new){
              this.$store.dispatch('determine_steps');
          }
        }
      }).catch(error => {
        logger.e(error);
      });
    },
    hasTieredPricing() {
      return TierHelper.hasTieredPricing(this.$store.getters.order_cart_items);
    }
  }
}